import styled from "@emotion/styled";

import { Select } from "metabase/ui";

export const FlexSelect = styled(Select)`
  flex: 1;
`;
